// extracted by mini-css-extract-plugin
export default {"modal":"Qda-z","modalContent":"Rda-z","footer":"Sda-z","cancelBtn":"Tda-z","disabled":"Uda-z","formWrapper":"Vda-z","fade":"Wda-z","fade-in":"Xda-z","iframe":"Yda-z"};